var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 27.955 27.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "ncGEUp.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.097,5.092c0-.654-.016-1.267.003-1.879.043-1.386.904-2.569,2.22-3.007.388-.129.815-.195,1.224-.196C13.861-.002,19.178-.002,24.495.004c2.016.002,3.452,1.435,3.455,3.452.006,5.327.007,10.654,0,15.981-.002,1.757-1.139,3.125-2.822,3.381-.505.077-1.029.035-1.544.044-.226.004-.452,0-.721,0,0,.374.012.718-.003,1.06-.022.504.005,1.022-.107,1.507-.356,1.538-1.69,2.52-3.358,2.522-3.69.004-7.38.001-11.071.001-1.627,0-3.254.006-4.881-.002-1.69-.008-3.009-1.046-3.359-2.641-.055-.25-.079-.511-.079-.767C0,19.195-.003,13.848.004,8.502c.003-1.739,1.132-3.106,2.808-3.36.612-.093,1.247-.038,1.871-.05.118-.002.236,0,.414,0ZM2.549,16.538c0,2.629,0,5.257,0,7.886,0,.708.276.981.993.981,5.267,0,10.534,0,15.801,0,.709,0,.986-.278.986-.994,0-5.267,0-10.534,0-15.801,0-.706-.284-.986-.998-.986-5.257,0-10.514,0-15.771,0-.738,0-1.011.27-1.011.998,0,2.638,0,5.277,0,7.915ZM22.862,20.33c.549,0,1.053.001,1.557,0,.709-.002.985-.281.985-.996,0-5.258,0-10.516,0-15.774,0-.75-.265-1.011-1.024-1.011-5.248,0-10.496,0-15.745,0-.089,0-.179-.003-.268.003-.373.028-.691.27-.712.638-.035.619-.01,1.242-.01,1.901h.391c3.77,0,7.54.002,11.31-.002.532,0,1.054.048,1.536.282,1.327.644,1.98,1.712,1.979,3.186-.002,3.78,0,7.56,0,11.34v.432Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.713,15.241c.144,0,.251,0,.358,0,1.131,0,2.261-.009,3.392.003.921.01,1.527.817,1.264,1.656-.168.536-.646.884-1.24.887-1.14.005-2.281.001-3.422.002-.107,0-.213,0-.352,0,0,.135,0,.242,0,.348,0,1.131.008,2.261-.003,3.392-.009.952-.849,1.567-1.7,1.264-.512-.183-.84-.643-.843-1.211-.005-1.14-.002-2.281-.002-3.422,0-.108,0-.217,0-.371-.117,0-.221,0-.325,0-1.131,0-2.261.002-3.392,0-.794-.002-1.354-.528-1.356-1.266-.002-.74.552-1.274,1.346-1.279,1.121-.007,2.241-.002,3.362-.002.108,0,.216,0,.365,0,0-.124,0-.23,0-.335,0-1.16-.005-2.321.003-3.481.005-.632.455-1.142,1.069-1.245.589-.099,1.193.252,1.386.829.061.184.084.388.085.584.008,1.091.004,2.182.004,3.273,0,.108,0,.217,0,.375Z",
    fill: "currentColor"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewQuery);
export default __webpack_public_path__ + "static/media/NewQuery.8dc8d08f.svg";
export { ForwardRef as ReactComponent };